import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { ModalDialog } from 'core-components/library/modalDialog'
import { MeasureController } from 'core/analytics'
import { TRANSLATION_KEYS } from 'partner360/features/contacts/model/constants'

import { ExtendedPartnerContacts } from '../partnerContacts/ExtendedPartnerContacts'

import styles from './ExtendedPartnerContactsDialog.module.scss'

interface IExtendedPartnerContactsDialogProps {
  show: boolean
  partnerId: string
  programType: ProgramTypes
  metrics: MeasureController
  onClose: () => void
}

export const ExtendedPartnerContactsDialog: FC<IExtendedPartnerContactsDialogProps> = ({
  show,
  metrics,
  partnerId,
  programType,
  onClose,
}) => {
  return (
    <ModalDialog
      closeOnOutsideClick={false}
      show={show}
      onClose={onClose}
      classes={{
        window: styles.window,
        body: styles.body,
      }}
      size="lg"
      header={() => (
        <div className={styles.header}>
          <Translation text={TRANSLATION_KEYS.widgetTitle} />
        </div>
      )}
      content={ExtendedPartnerContacts}
      contentProps={{
        metrics,
        partnerId,
        programType,
        onClose,
      }}
    />
  )
}
